import styled from "styled-components";
import {
  useGetPowerBanksQuery,
  useOnPowerBankUpdatedSubscription,
} from "../../../data/generated";
import { theme } from "../../../theme";
import { PowerBankDetailsRow } from "./PowerBankDetailsRow";
import { Loader } from "../../../design-system/atoms/Loader";

export const PowerBanksList = ({
  filters,
}: {
  filters: {
    powerBankSerialNumber: string;
    transactionId: string;
    isInTransaction: boolean | null;
  };
}) => {
  const { data, loading, error, fetchMore } = useGetPowerBanksQuery({
    variables: { limit: 50, offset: 0, filters },
    fetchPolicy: "cache-and-network",
  });

  useOnPowerBankUpdatedSubscription();

  if (error) {
    return null;
  }

  if (loading || !data) {
    return <Loader />;
  }

  const {
    powerBanks: { powerBanks, hasMore },
  } = data;

  function handleScroll({ currentTarget }: React.UIEvent<HTMLDivElement>) {
    if (
      currentTarget.scrollTop + currentTarget.clientHeight >=
      currentTarget.scrollHeight
    ) {
      if (hasMore) {
        fetchMore({
          variables: {
            offset: powerBanks.length,
            limit: 20,
            filters,
          },
        });
      }
    }
  }

  return (
    <Container onScroll={handleScroll}>
      <Table>
        <thead>
          <Tr>
            <Th>Serial Number</Th>
            <Th $isCentered>Battery left</Th>
            <Th>Module Serial Number</Th>
            <Th>Slot index</Th>
            <Th>Transaction ID</Th>
            <Th>Actions</Th>
          </Tr>
        </thead>
        <tbody>
          {powerBanks.map((powerBank) => (
            <PowerBankDetailsRow key={powerBank._id} powerBank={powerBank} />
          ))}
        </tbody>
      </Table>
      {powerBanks.length === 0 && (
        <NoResultContainer>
          <p>No power banks found</p>
        </NoResultContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  border: 1px solid ${theme.borderColor.highlight};
  border-radius: 10px;
`;

const Table = styled.table`
  min-width: 100%;
  max-height: 100%;
  overflow-x: auto;
`;

const Tr = styled.tr`
  background-color: ${theme.backgroundColor};
`;

const Th = styled.td<{ $isCentered?: boolean }>`
  position: sticky;
  top: 0px;
  background-color: ${theme.backgroundColor};
  font-weight: bold;
  text-align: ${({ $isCentered }) => ($isCentered ? "center" : "left")};
  padding: 5px;
`;

const NoResultContainer = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.textColor.secondary};
`;
